/**
 * useStaticTagOptions — "No tag" + the shared Static Tag catalogue as
 * SearchableSelect options, each dot in the tag's own hex color (a stored
 * value, so an inline style, not a class). Shared by the flow form and the
 * flow bulk editor (MD-1024); "" is the deliberate "No tag" pick.
 * For Media Devoted | Created By James Alexandrov
 */

import { useMemo } from "react";

import type { SearchableSelectOption } from "@/components/ui";
import { useStaticTags } from "@/hooks/smswiser";

export function useStaticTagOptions(): {
  tagOptions: SearchableSelectOption[];
  tagNameById: Map<string, string>;
} {
  const { data: tags } = useStaticTags();
  const tagOptions = useMemo(
    () => [
      { value: "", label: "No tag" },
      ...(tags ?? []).map((t) => ({
        value: t.id,
        label: t.name,
        optionContent: (
          <span className="inline-flex items-center gap-2">
            <span
              className="h-2 w-2 shrink-0 rounded-full"
              style={{ backgroundColor: t.color || "#6b7280" }}
              aria-hidden
            />
            {t.name}
          </span>
        ),
      })),
    ],
    [tags],
  );
  const tagNameById = useMemo(
    () => new Map((tags ?? []).map((t) => [t.id, t.name])),
    [tags],
  );
  return { tagOptions, tagNameById };
}
